import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

export function Accordion({
  title,
  children,
  defaultOpen = false,
  className,
}: AccordionProps): JSX.Element {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div
          className={clsx(
            'border py-1 border-[#F0F0F0] rounded-lg overflow-hidden',
            className,
          )}
        >
          <Disclosure.Button className="w-full flex justify-between items-center p-2 text-[#434343] font-[400] text-left min-w-0">
            <div className="flex-1 min-w-0">{title}</div>
            <span className="flex-shrink-0">
              <ChevronDownIcon
                className={`w-5 h-5 ml-2 transform transition-transform duration-200 ${
                  open ? 'rotate-180' : ''
                }`}
              />
            </span>
          </Disclosure.Button>
          <Disclosure.Panel className="transition-all duration-300 ease-in-out">
            <div className="p-2">{children}</div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}
